// ============================================
// Global Events Module (ES6)
// 전역 이벤트 위임 - onclick 대체
// ============================================

import { showContentDetail } from './home/detail.js';
import { deletePublished } from './mypage/works.js';
import { switchTab } from './app/navigation.js';

// ============================================
// Global Click Event Delegation
// ============================================

function initGlobalEvents() {
  document.addEventListener('click', (e) => {
    // === Content Detail ===
    // data-content-id 클릭 시 상세 보기
    const contentCard = e.target.closest('[data-content-id]');
    if (contentCard) {
      const deleteBtn = e.target.closest('[data-action="delete-published"]');
      if (!deleteBtn) {
        const contentId = contentCard.dataset.contentId;
        if (contentId) {
          showContentDetail(contentId);
        }
      }
      return;
    }

    // === Action-based Events ===
    const actionEl = e.target.closest('[data-action]');
    if (actionEl) {
      const action = actionEl.dataset.action;

      switch (action) {
        case 'switch-tab':
          const tab = actionEl.dataset.tab;
          if (tab && typeof switchTab === 'function') {
            switchTab(tab);
          }
          break;

        case 'delete-published':
          e.stopPropagation();
          const publishedId = actionEl.dataset.id;
          if (publishedId) {
            deletePublished(publishedId);
          }
          break;
      }
    }
  });

  console.log('[Global Events] 전역 이벤트 위임 초기화 완료');
}

// ============================================
// 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGlobalEvents);
} else {
  initGlobalEvents();
}
